import React from "react";
import {SvarInputTypeProps} from "./svarInputTypeCompareMap";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {BesvaretAf} from "../readSvar/besvaretAf";

export function NummerInputSvar({
                                    spoergsmaal,
                                    svarNummerIndex,
                                    kompetenceSvarList,
                                    indsendt,
                                    nummerCallback,
                                    readOnly
                                }: SvarInputTypeProps) {
    const stempel = kompetenceSvarList.find(x => x.svarIndex === svarNummerIndex)?.stempel;
    return (
        <>
            <div className={"margin-bottom-s"} key={spoergsmaal.id + svarNummerIndex}>
                <label
                    htmlFor={`nummerSvar ${svarNummerIndex}`}>{Localizer.evalueringPage_angivNummeriskVaerdi()}</label>
                <input type="number"
                       name={`nummerSvar ${svarNummerIndex}`}
                       className="form-control"
                       defaultValue={kompetenceSvarList.find(x => x.svarIndex === svarNummerIndex)?.nummerSvar ?? undefined}
                       onBlur={(e) => nummerCallback(parseInt(e.target.value), svarNummerIndex)}
                       disabled={indsendt || readOnly}
                       placeholder={Localizer.evalueringPage_angivNummeriskSvar()}/>
            </div>
            {stempel &&
                <BesvaretAf
                    stempel={stempel}/>
            }
        </>)
}
